export enum PermissionAccessActions {
    NONE = 0,
    FULL = 1,
    READ = 2,
    WRITE = 3
}
